import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getIsDateWithinXDays } from '@wix/da-ds/pkg/Time/functions';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './CoreMenuItem.scss';
const CoreMenuItem = ({ className, hasCoreMembership, coreLevel, coreExpires })=>{
    const { t } = useTranslation();
    const isUpgradableCoreLevel = coreLevel === 'core_access' || coreLevel === 'core_plus';
    const coreExpiresIn30 = coreExpires && getIsDateWithinXDays(coreExpires, 30);
    const upgradableAndExpiringCore = isUpgradableCoreLevel && coreExpiresIn30;
    const showUpgradeIndicator = !hasCoreMembership || upgradableAndExpiringCore;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, hasCoreMembership && coreLevel && s[`package-${coreLevel}`])
    }, showUpgradeIndicator ? /*#__PURE__*/ React.createElement(CoreUpgradeIndicator, {
        className: classnames(hasCoreMembership && s['ds-override'])
    }, t(hasCoreMembership ? 'siteHeader.userMenu.coreMenuItem.upgradeCore' : 'siteHeader.userMenu.coreMenuItem.getCore')) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, hasCoreMembership && coreLevel ? t(`siteHeader.userMenu.coreLabel.${coreLevel}`) : t('siteHeader.userMenu.buyCoreMembership')), /*#__PURE__*/ React.createElement("span", null, !hasCoreMembership && /*#__PURE__*/ React.createElement(CoreBadge, {
        corePackage: coreLevel,
        className: s['core-icon'],
        size: "large"
    }))));
};
CoreMenuItem.displayName = 'CoreMenuItem';
export default CoreMenuItem;
